module.exports = __webpack_public_path__ + "static/media/metcoppo.da57dc3f.pdf";